import {FCX} from "@datassential/platform-ui-lib";
import {UnitType} from "@models";
import {useUserContext} from "@core/UserContext";
import React, {memo, useMemo} from "react";
import LockAccessOverlay from "@components/LockAccessOverlay";
import cn from "classnames";

const AnalyzePerformanceChartWrapper: FCX<{
    subTitle: string;
    toolLocation: string;
    selectedUnit: UnitType;
}> = ({
    className,
    children,
    testId,
    subTitle,
    toolLocation,
    selectedUnit,
}) => {
    const {fullAccess} = useUserContext();

    const noAccess = useMemo(
        () => selectedUnit === UnitType.Pct && !fullAccess,
        [selectedUnit, fullAccess]
    )

    return (
        <div
            className={
                cn(
                   "AnalyzePerformanceChartWrapper",
                    className
                )
            }
            data-testid={testId}
        >
            {children}
            {noAccess && (
                <LockAccessOverlay
                    subTitle={subTitle}
                    toolLocation={toolLocation}
                />
            )}
        </div>
    )
}

export default memo(AnalyzePerformanceChartWrapper);